import { render, staticRenderFns } from "./BrainMachine.vue?vue&type=template&id=fad3beb2&scoped=true"
import script from "./BrainMachine.vue?vue&type=script&lang=js"
export * from "./BrainMachine.vue?vue&type=script&lang=js"
import style0 from "./BrainMachine.vue?vue&type=style&index=0&id=fad3beb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad3beb2",
  null
  
)

export default component.exports